import React from "react";
import { Route } from "react-router-dom";
import { Box } from "@mui/material";
import LazyRoute from "./LazyRoute";
import {
  Dashboard,
  Blacklist,
  AdsRecords,
  GoogleAds,
  IdleAccounts,
  EmailManagement,
  MySettings,
  PermissionManagement,
  Profile,
  OfferDetail,
  OfferEdit,
  RecommendedOffers,
  PostBack,
} from "../utils/lazyImports";

/**
 * 应用内多标签区域的路由表（Fragment，非组件）。
 * React Router v6 要求 <Routes> 的子节点只能是 <Route> 或 <React.Fragment>，不能是自定义包装组件。
 * TabContent 可为每个标签渲染一套 <Routes location={...}>{tabRouteElements}</Routes>。
 */
export const tabRouteElements = (
  <React.Fragment>
    <Route
      path="/"
      element={
        <LazyRoute
          component={Dashboard}
          loadingMessage="加载仪表板..."
        />
      }
    />
    <Route
      path="/dashboard"
      element={
        <LazyRoute
          component={Dashboard}
          loadingMessage="加载仪表板..."
        />
      }
    />
    <Route
      path="/blacklist"
      element={
        <LazyRoute
          component={Blacklist}
          loadingMessage="加载黑名单..."
        />
      }
    />
    <Route
      path="/ads-records"
      element={
        <LazyRoute
          component={AdsRecords}
          loadingMessage="加载广告记录..."
        />
      }
    />
    <Route
      path="/google-ads"
      element={
        <LazyRoute
          component={GoogleAds}
          loadingMessage="加载Google Ads..."
        />
      }
    />
    <Route
      path="/idle-accounts"
      element={
        <LazyRoute
          component={IdleAccounts}
          loadingMessage="加载空闲账号..."
        />
      }
    />
    <Route
      path="/email-management"
      element={
        <LazyRoute
          component={EmailManagement}
          loadingMessage="加载邮箱管理..."
        />
      }
    />
    <Route
      path="/settings"
      element={
        <LazyRoute
          component={MySettings}
          loadingMessage="加载设置..."
        />
      }
    />
    <Route
      path="/permission-management"
      element={
        <LazyRoute
          component={PermissionManagement}
          loadingMessage="加载权限管理..."
        />
      }
    />
    <Route
      path="/recommended-offers"
      element={
        <LazyRoute
          component={RecommendedOffers}
          loadingMessage="加载收藏Offer..."
        />
      }
    />
    <Route
      path="/post-back"
      element={
        <LazyRoute component={PostBack} loadingMessage="加载 Post Back..." />
      }
    />
    <Route
      path="/profile"
      element={
        <LazyRoute
          component={Profile}
          loadingMessage="加载个人资料..."
        />
      }
    />
    <Route
      path="/offers/:id"
      element={
        <LazyRoute
          component={OfferDetail}
          loadingMessage="加载Offer详情..."
        />
      }
    />
    <Route
      path="/offers/:id/edit"
      element={
        <LazyRoute
          component={OfferEdit}
          loadingMessage="加载Offer编辑..."
        />
      }
    />
    <Route
      path="*"
      element={<Box component="p" sx={{ p: 2 }}>页面未找到</Box>}
    />
  </React.Fragment>
);
